import { ArchiveIcon, ShoppingCartIcon } from "@heroicons/react/outline";
import CertSummary from "./CertSummary";
import CreateACopyButton from "./CreateACopyButton";
import SearchResultShopify from "./SearchResultShopify";

function SearchResultLayout({ bgcol, icon, title, children }) {
  return (
    <div className={`border m-2 shadow-sm flex`}>
      <div className={`w-17 p-2 mr-2 ${bgcol}`}>{icon}</div>
      <div className="w-60 text-lg pt-1 pr-2 border-r-2 border-slate-300">
        {title}
      </div>
      <div className="flex-1 p-2">{children}</div>
    </div>
  );
}

function SearchResult({ r, q, setAndDo }) {
  if (!r || !r.type) {
    // throw Error(`Invalid search result object: ${JSON.stringify(r)}`);
    return (
      <div className="bg-red-200 p-4 m-2">
        <pre>{JSON.stringify({ r, q }, null, 2)}</pre>
      </div>
    );
  }

  switch (r.type) {
    case "shopifyOrders":
      return (
        <SearchResultLayout
          bgcol="bg-emerald-100"
          icon={<ShoppingCartIcon className="size-6" />}
          title={
            <>
              <p>Shopify Order {r.result.name}</p>
              <p className="text-sm">
                {(r.result.customer || {}).first_name}{" "}
                {(r.result.customer || {}).last_name}
              </p>
            </>
          }
        >
          <SearchResultShopify q={q} r={r} setAndDo={setAndDo} />
        </SearchResultLayout>
      );
    case "oldCert":
      return (
        <SearchResultLayout
          bgcol="bg-green-200"
          icon={<ArchiveIcon className="size-6" />}
          title={`Old certificate, number ${r.result.certNumber}${r.result.score ? ` Search score is ${r.result.score.toFixed(2)}` : ""}`}
        >
          <CertSummary cert={r.result} q={q} certSearchKeyMatch={r.result.k}>
            <CreateACopyButton cert={r.result} />
            {r.result.shopifyLink && (
              <a
                href={r.result.shopifyLink}
                target="_blank"
                rel="noreferrer noopener"
                className="btn btn-secondary relative -top-2"
              >
                Click to open Shopify order
              </a>
            )}
          </CertSummary>
        </SearchResultLayout>
      );
    default:
      return (
        <SearchResultLayout title="Unknown type">{r.type}</SearchResultLayout>
      );
  }
}

export default SearchResult;
